const translation = {
  // 通用
  common: {
    brandName: "AtlasSlicer 2D",
    loading: "加载中...",
    refresh: "刷新",
    logout: "退出",
    login: "登录",
    processing: "处理中...",
    error: "错误",
    success: "成功",
    selectLanguage: "选择语言"
  },

  // 语言
  languages: {
    english: "English",
    chinese: "中文"
  },
  
  // 导航
  nav: {
    home: "首页",
    features: "核心功能",
    download: "下载客户端",
    pricing: "购买授权",
    buyNow: "立即购买",
    about: "关于"
  },
  
  // 页脚
  footer: {
    description: "AtlasSlicer 2D 是专为 2D 独立游戏开发者与美术师打造的专业图集全流程工作台，集 Rust 高速图集打包、4合1智能多模式切片拆图与实时动效质检播放器于一体。100% 纯本地极速计算，美术资产绝对隐私安全。",
    services: "产品服务",
    contactUs: "联系我们",
    changelog: "更新记录",
    about: "关于",
    userAgreement: "用户协议",
    privacyPolicy: "隐私政策",
    refundPolicy: "退款政策",
    followUs: "关注我们",
    supportTitle: "联系技术支持",
    supportDesc: "遇到任何使用、引擎适配或支付问题，欢迎随时联系支持团队：",
    customerSupport: "技术支持",
    copyright: "版权所有 © 2025-2026 AtlasSlicer. 保留所有权利。"
  },
  
  // 首页
  home: {
    badge: "专为 2D 独立游戏开发者与美术师打造",
    title: "AtlasSlicer 2D 图集工作台",
    subtitle: "图集打包 · 智能拆图 · 动效质检 · 多引擎通用",
    description: "告别繁琐流程与边缘漏色！AtlasSlicer 2D 融合 Rust 高速图集装箱打包（MaxRects/POT/Extrude）、4合1 智能切片（Alpha识别/规则网格/绿幕抠图/自由切分）与序列帧动画播放质检，原生适配 10 大游戏引擎与自定义模板，全面提速游戏开发资产管线。",
    getStarted: "获取终身授权",
    viewDemo: "浏览核心功能",
    downloadClient: "下载客户端",
    previewTitle: "Texture Atlas & Slicing",
    previewDesc: "智能识别边界框，保留像素级边缘，无缝对接各大主流游戏引擎。",
    alphaClosed: "✓ 智能 Alpha 边缘闭合与防溢色",
    features: {
      fast: "Rust 原生打包",
      fastDesc: "基于 MaxRects 算法的高速图集装箱，支持 POT/NPOT 与 Extrude 像素挤出防漏色",
      accurate: "4合1 智能拆图",
      accurateDesc: "支持透明度连通域智能识别、规则网格、绿幕单色抠图及手动自由切割",
      flexible: "动效质检播放器",
      flexibleDesc: "直接预览提取的序列帧动画，支持 1~60 FPS 换算与 Loop / PingPong 播放",
      safe: "10大引擎与离线安全",
      safeDesc: "原生兼容 Unity、Godot 4、Cocos、Phaser 等格式，100% 纯本地运行绝不上云"
    },
    faq: {
      title: "常见问题解答",
      questions: [
        {
          question: "AtlasSlicer 2D 是一款什么样的工具？",
          answer: "AtlasSlicer 2D 是一套面向 2D 游戏开发者的全流程资产工作台，融合了【图集打包器（TexturePacker）】、【智能拆图切片（Slicer）】与【序列帧动效播放质检（Animation Player）】三大核心模块，彻底打通游戏素材的导入、切片、优化与打包管线。"
        },
        {
          question: "图集打包（Packer）支持哪些高级特性？",
          answer: "搭载 Rust 原生 MaxRects 算法（提供 BSSF 最佳短边适应、BLSF 最佳长边适应、BAF 最佳面积适应三种启发式策略），支持正方形自适应装箱（Square Grid Wrap）、POT（2的幂次方）及 NPOT 尺寸约束、Padding 间隙以及 Extrude 边缘像素外扩挤出（彻底消除 3D 渲染与双线性过滤时的边缘溢色透底问题）。"
        },
        {
          question: "面对没有配置文件的纯图片，如何精准切片？",
          answer: "内置 4 种拆图模式：1. 智能 Alpha 连通域分析（带容差与最小过滤面积，自动圈定异形元件）；2. 规则网格均匀切分（自定义行列数与长宽）；3. 绿幕/单色底色抠图切分（智能消除底色提取元件）；4. 手动自由参考线切分（直接在画板上拖拉切割线）。"
        },
        {
          question: "支持导出到哪些游戏引擎和格式？",
          answer: "原生支持 Unity (.meta/Sprite JSON)、Godot 4 (.tres)、Cocos2d-x (.plist)、Phaser 3 (JSON Hash/Array)、Starling (XML)、LibGDX (.atlas)、LayaAir (.atlas/json)、Love2D (Lua table)、CSV 数据表、TexturePacker JSON (Hash/Array) 等 10 大引擎及格式，并支持基于模板引擎的自定义 XML/JSON 导出规则。"
        },
        {
          question: "我的游戏美术资产会被上传到服务器吗？",
          answer: "绝不上传！AtlasSlicer 2D 是一款 100% 纯本地离线运行的桌面工具，所有图像算法（Rust 原生核心与本地渲染）均在您的电脑内存中完成计算，无任何云端回传，保障商业级游戏资产的绝对保密。"
        },
        {
          question: "购买后是终身使用还是订阅制？",
          answer: "AtlasSlicer 2D 采用一次性终身买断制（Lifetime License），没有任何按月或按年订阅。购买成功后，系统会立即向您的付款邮箱发送终身激活密钥（License Key），输入 Key 即可永久激活软件全部专业功能并享受后续所有版本的免费更新。"
        }
      ]
    }
  },
  
  // 关于页面
  about: {
    title: "关于 AtlasSlicer 2D",
    content: "AtlasSlicer 2D 专注于为全球独立游戏开发者和 2D 美术师提供更高效、更纯粹的素材管线生产力工具，让图集打包、拆解与动效质检不再繁琐。"
  },
  
  // 功能页面
  features: {
    badge: "AtlasSlicer 2D 全流程能力",
    title: "专为 2D 游戏开发定制的专业工作台",
    subtitle: "打通「图集打包 - 智能拆解 - 动效质检 - 多引擎导出」完整素材管线",
    description: "告别简陋的单功能工具与昂贵的订阅软件。AtlasSlicer 2D 凭借 Rust 核心算力与高水准界面，为独立开发者与团队提供开箱即用的专业级资产处理体验。",
    packer: {
      title: "Rust 原生 MaxRects 图集打包",
      description: "搭载 Rust 原生装箱引擎，毫秒级完成数百张精灵的高密度排布，显著节省游戏显存与 Draw Call。",
      features: [
        "支持 BSSF、BLSF、BAF 三大 MaxRects 启发式装箱算法",
        "支持正方形自适应装箱（Square Grid Wrap）与自由长宽比",
        "POT（2的幂次方如 1024/2048/4096）与 NPOT 尺寸约束",
        "Padding 内边距 与 Extrude 像素外扩挤出（彻底杜绝渲染边缘溢色 Bleeding）"
      ]
    },
    slicer: {
      title: "4合1 智能切片与精灵提取",
      description: "无论是一整张合并 SpriteSheet 还是带底色的游戏老图，四大专业模式助您瞬间分解出精准帧序列。",
      features: [
        "Alpha 连通域智能识别：像素级吸附轮廓，可调容差与最小过滤面积",
        "规则网格等距切分：支持按行列数或固定像素步长均匀分割",
        "绿幕 / 单色底色智能抠图：指定底色并调节容差，秒级提取无背景精灵",
        "手动自由参考线切分：在画板上拖动垂直/水平分割线，自由定制边界"
      ]
    },
    animation: {
      title: "实时序列帧动效质检与高清动图导出",
      description: "无需导入游戏引擎即可在软件内直接验收切片动画，并支持一键导出透明高清动图。",
      features: [
        "切片选区一键生成动画预览，实时检查帧对齐与抖动",
        "1 ~ 60 FPS 动态帧率无级调节、支持单次 / 循环 / PingPong 往返播放",
        "支持导出透明 GIF / APNG / WebP 序列帧动图（带 1x~8x 像素级无损放大）",
        "支持逐帧步进（Step Forward / Backward）与精准暂停质检"
      ]
    },
    engines: {
      title: "10 大主流游戏引擎与自定义模板",
      description: "无缝对接全球主流 2D/3D 游戏引擎，告别重复手工配表与坐标转换。",
      features: [
        "原生支持 Unity (.meta/JSON)、Godot 4 (.tres)、Cocos2d-x (.plist)、Phaser 3",
        "全面覆盖 Starling (XML)、LibGDX (.atlas)、LayaAir、Love2D (Lua)、CSV",
        "TexturePacker JSON (Hash / Array) 工业标准全兼容",
        "内置灵活强大的自定义 XML / JSON 模板引擎，随心适配自研引擎"
      ]
    },
    security: {
      title: "100% 纯本地离线隐私与极致性能",
      description: "商业美术资产关乎项目生命线，AtlasSlicer 2D 全面保障您的素材隐私。",
      features: [
        "基于 Rust 原生核心打造，毫秒级快速响应与极低内存占用",
        "零云端传输、零隐私追踪，拔掉网线依然 100% 顺畅运行",
        "现代化毛玻璃与深浅色主题，长时间使用舒适护眼"
      ]
    },
    offlineIllustration: {
      title: "100% 本地运算沙盒",
      desc: "所有装箱、切片与渲染算法均在本地内存与硬件完成，零网络回传",
      encrypted: "🔒 内存级纯本地计算",
      latency: "⚡ 0ms 零网络延迟"
    },
    crossIllustration: {
      textureTitle: "4K / 8K",
      textureDesc: "超大分辨率图集轻松承载",
      platformTitle: "Rust + Tauri",
      platformDesc: "轻巧原生高效跨平台"
    },
    content: "让 AtlasSlicer 2D 成为您游戏资产管线中最强大的生产力引擎！",
    ctaSubtitle: "14 天无理由退款保障 · 一次买断终身享用 · 永久免费升级"
  },
  
  // 定价页面
  pricing: {
    badge: "终身买断 · 纯净无广告 · 永久免费更新",
    title: "简单透明的终身授权",
    subtitle: "一次付费，永久使用。无任何按月/按年隐藏订阅，解锁全部专业功能。",
    planTitle: "AtlasSlicer 2D 个人专业版",
    planSubtitle: "专为独立开发者、游戏工作室与 2D 美术师打造",
    lifetime: "终身授权",
    buyNowBtn: "立即通过 Paddle 安全购买",
    includes: "包含全部专业工作台特性：",
    successTitle: "🎉 恭喜！购买成功！",
    successMessage: "您的终身激活密钥（License Key）已发送至您的付款邮箱，感谢您对独立游戏工具开发的支持！",
    errorNotReady: "支付模块尚未就绪，请稍后重试。",
    errorOpenFailed: "打开支付窗口失败，请刷新重试。",
    connectingGateway: "正在连接安全结账网关...",
    preparingPayment: "正在准备支付组件...",
    securityBadge: "Paddle 官方全球合规安全结账",
    paymentMethods: "支持 Visa、MasterCard、PayPal、银联等",
    moneyBackGuarantee: "14 天无理由退款保障",
    features: {
      packer: "突破 200 张上限：无限图元纳管、多页图集自动分包与 4K/8K 超高清导出",
      slicer: "4合1 智能切片（Alpha识别 / 规则网格 / 绿幕抠图 / 自由分割）与批量重命名",
      animation: "动效质检播放与导出透明 GIF / APNG / WebP 动图（带 1x~8x 像素级放大）",
      engines: "边缘像素挤出 (Extrude) 防黑边渗色、10 大主流引擎与自定义模板导出",
      offline: "100% 纯本地离线运行，零云端上传，商业美术资产绝对保密",
      updates: "终身买断授权，单 Key 支持激活 3 台个人设备（支持自助解绑）与免费更新"
    }
  },

  // 下载页面
  download: {
    badge: "v1.0.0 正式版已发布",
    title: "下载 AtlasSlicer 2D 桌面客户端",
    description: "专为 Windows、macOS 打造的专业独立桌面客户端。支持拖拽极速装箱、4合1智能切片与动效质检。购买后凭邮箱收到的终身激活密钥（License Key）即可在软件中一键激活永久使用。",
    downloadWin: "下载 Windows 客户端 (.exe)",
    downloadWinInstaller: "下载 Windows 安装包 (.exe)",
    downloadWinPortable: "下载 Windows 绿色便携版 (.zip)",
    downloadWinArm: "Windows ARM64 专用版",
    downloadMac: "macOS 客户端 (即将上线)",
    downloadMacDmg: "下载 macOS 客户端 (.dmg)",
    recommendedTag: "推荐安装",
    nativeTag: "原生架构",
    winPlatformDesc: "支持 Windows 10 / 11 64位系统。纯本地离线计算，GPU 硬解加速。",
    macPlatformDesc: "支持 Apple Silicon (M1/M2/M3/M4) 与 Intel 架构 Mac 设备。",
    historyTitle: "历史版本下载",
    historyDesc: "提供所有已发布的历史版本，支持按需回退下载旧版本。",
    historyInstaller: "安装包 (.exe)",
    historyPortable: "绿色包 (.zip)",
    historyMac: "macOS (.dmg)",
    releaseDate: "发布日期",
    currentBadge: "最新稳定版",
    viewChangelog: "查看更新内容",
    portableNotice: "绿色免安装版，解压即可直接运行",
    getLicense: "获取终身激活密钥",
    backHome: "返回官网首页",
    versionInfo: "当前版本：v1.0.0 正式版 | 纯本地离线运行 | 支持 Windows 10/11 64位",
    licenseTitle: "激活说明",
    licenseNote: "软件内置免费社区版开箱即用；在右上角【升级 Pro】或【设置 -> Pro 授权】中输入您的 License Key 即可立即解锁全部专业特权（单码支持激活 3 台设备）。",
    smartScreenTip: "若提示「未知开发者」：点击【更多信息】➜【仍要运行】即可正常使用",
    securityTitle: "安全与安装说明（关于 Windows 未知发布者提示）",
    securityDesc: "由于本软件为独立个人开发者倾力制作，尚未购买商业代码签名证书，Windows SmartScreen 可能会弹出「未知发布者」或「Windows 已保护你的电脑」的安全提示。AtlasSlicer 2D 坚持 100% 纯本地离线运行与硬解加速，绝不上报隐私数据，请放心使用：",
    securityStep1: "若弹出系统拦截弹窗，点击弹窗中的「更多信息」",
    securityStep2: "点击随后出现的「仍要运行」按钮，即可正常安装与启动",
    securityStep3: "您也可以优先选用上方的「绿色便携版 (.zip)」，免安装解压即用"
  },

  // 错误显示
  error: {
    refreshPage: "刷新页面",
    apiConfig: {
      title: "API配置错误",
      checkEnv: "请检查您的环境变量，确保正确设置了API URL和API密钥。",
      createFile: "在项目根目录创建.env.local文件并添加：",
      reload: "重新加载"
    }
  }
};

export default translation;
